export default __webpack_public_path__ + "static/media/robot-green.975a754d.svg";